'use client';

export default function EcoIconCheckboxN({ className, ...reset }: { className?: string }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            fill="none"
            className={`eco-icon-checkbox-n${className ? ` ${className}` : ''}`}
            {...reset}
        >
            <mask id="path-1-inside-1_260_1713" fill="white">
                <path d="M2 3.33333C2 2.59695 2.59695 2 3.33333 2H12.6667C13.403 2 14 2.59695 14 3.33333V12.6667C14 13.403 13.403 14 12.6667 14H3.33333C2.59695 14 2 13.403 2 12.6667V3.33333Z" />
            </mask>
            <path
                d="M3.33333 3.5H12.6667V0.5H3.33333V3.5ZM12.5 3.33333V12.6667H15.5V3.33333H12.5ZM12.6667 12.5H3.33333V15.5H12.6667V12.5ZM3.5 12.6667V3.33333H0.5V12.6667H3.5ZM3.33333 12.5C3.42538 12.5 3.5 12.5746 3.5 12.6667H0.5C0.5 14.2315 1.76853 15.5 3.33333 15.5V12.5ZM12.5 12.6667C12.5 12.5746 12.5746 12.5 12.6667 12.5V15.5C14.2315 15.5 15.5 14.2315 15.5 12.6667H12.5ZM12.6667 3.5C12.5746 3.5 12.5 3.42538 12.5 3.33333H15.5C15.5 1.76853 14.2315 0.5 12.6667 0.5V3.5ZM3.33333 0.5C1.76853 0.5 0.5 1.76853 0.5 3.33333H3.5C3.5 3.42538 3.42538 3.5 3.33333 3.5V0.5Z"
                fill="#3F68E0"
                mask="url(#path-1-inside-1_260_1713)"
            />
        </svg>
    );
}
